import { render } from "./addsolid.vue?vue&type=template&id=d45af8e2&scoped=true"
import script from "./addsolid.vue?vue&type=script&lang=js"
export * from "./addsolid.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45af8e2"]])

export default __exports__